<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/groups/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Csoport</h1>
          <div class="row">
            <div class="col-sm-3">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
              <div>
                <h2>Csatolt elemek</h2>
                <div class="selected-items-list" v-if="selected_elements.length > 0">
                  <div class="item" v-for="element in selected_elements">
                    <button v-on:click="removeElement(element.id)" class="button small"><i class="fa fa-trash"></i></button>
                    {{ element.name }}
                  </div>
                </div>
                <div class="normal-text" v-else>
                  Nem található csatolt elem.
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <comboboxV2 :change="changeGroupType" id="group_type_id" label="Csoport típusa" v-bind:errors="errors" name="group_type_id" :options="group_types" v-model="form.type_id"></comboboxv2>
            </div>
            <div class="col-sm-3">
              <comboboxV2 :change="elementTypeChange" id="element_type_id" label="Csoporton belül engedélyezett elem típusok" v-bind:errors="errors" name="element_type_id" :options="enabled_element_types" v-model="element_type_id"></comboboxv2>
              <div class="selected-items-list">
                <div v-if="showElement(element.id)" class="item" v-for="element in elements">
                  <button v-on:click="addElement(element.id)" class="button small"><i class="fa fa-chevron-left"></i></button>
                  {{ element.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        element_id: 0,
        group_type_id: 0,
        name: '',
        item_ids: []
      },
      element_types: [],
      enabled_element_types: [],
      element_type_id: 0,
      group_types: [],

      elements: [],
      selected_elements: [],

      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('group/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.groupID != undefined ? _this.$route.query.groupID : 0), {
        success: function(response) {
          _this.form = response.group;

          _this.getElementTypes(() => {
            _this.getGroupTypes(() => {
              if (_this.form.type_id == 0)
                _this.form.type_id = _this.group_types[0].value;

              _this.setEnabledElementTypes();
              _this.getElementsByID();
            });
          });
        }
      });
    });
  },

  methods: {
    showElement: function(element_id) {
      var show = true;
      this.form.item_ids.map(function(id) {
        if (id == element_id)
          show = false;
      });
      return show;
    },

    removeElement: function(element_id) {
      var tmp = [];
      this.form.item_ids.map(function(id) {
        if (id != element_id)
          tmp.push(id);
      });
      this.form.item_ids = tmp;

      var tmp = [];
      this.selected_elements.map(function(element) {
        if (element.id != element_id)
          tmp.push(element);
      });
      this.selected_elements = tmp;
    },

    addElement: function(id) {
      this.form.item_ids.push(id);
      this.getElementsByID();
    },

    elementTypeChange: function() {
      this.getElementsByType();
    },

    getElementsByID: function() {
      var _this = this;

      if (_this.form.item_ids.length == 0) {
        _this.selected_elements = [];
        return;
      }

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('elements/' + _this.$root.user.apikey, {
          method: 'POST',
          async: false,
          data: {
            id: _this.form.item_ids
          },
          success: function(response) {
            _this.selected_elements = [];
            response.elements.map(function(element) {
              _this.selected_elements.push({
                name: element.name + ' (' + element.type + ')',
                id: element.id
              });
            });
          }
        });
      });
    },

    getElementsByType: function() {
      var _this = this;

      if (_this.element_type_id == 0) {
        _this.elements = [];
        return;
      }

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('group/elements/' + _this.$root.user.apikey + '/' + _this.element_type_id, {
          async: false,
          method: 'GET',
          success: function(response) {
            _this.elements = [];
            response.elements.map(function(element) {
              _this.elements.push({
                name: element.name,
                id: element.id
              });
            });
          }
        });
      });
    },

    getElementTypes: function(cb) {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('get_element_types/' + _this.$root.user.apikey, {
          async: false,
          success: function(response) {
            response.types.map(function(type) {
              if (type.is_group == 0)
                _this.element_types.push({
                  label: type.name,
                  value: type.id,
                  alias: type.code
                })
            });
            if (cb != undefined)
              cb();
          }
        });
      });
    },

    getGroupTypes: function(cb) {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('get_group_types/' + _this.$root.user.apikey, {
          async: false,
          success: function(response) {
            response.types.map(function(type) {
              _this.group_types.push({
                label: type.name,
                value: type.id,
                element_types: type.element_types
              });
            });
            if (cb != undefined)
              cb();
          }
        });
      });
    },

    // Beállítja, hogy a kiválasztott csoport típushoz milyen elem típusokat lehet kapcsolni
    setEnabledElementTypes: function() {
      var _this = this;

      _this.enabled_element_types = [];

      this.group_types.map(function(group_type) {
        if (parseInt(group_type.value) == parseInt(_this.form.type_id)) {
          var group_element_types = group_type.element_types.split(',');

          _this.enabled_element_types.push({label: '- válassz -', value: 0});

          _this.element_types.map(function(element_type) {
            if (group_element_types.includes(element_type.alias)) {
              _this.enabled_element_types.push({label: element_type.label, value: element_type.value});
            }
          })
        }
      });
    },

    changeGroupType: function() {
      var _this = this;

      this.setEnabledElementTypes();

      this.elements = [];
      this.selected_elements = [];
      this.element_type_id = 0;
      this.form.item_ids = [];
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('group/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/groups'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// group.vue?39875600